import { ChevronRight } from 'lucide-react'
import { formatCredits, formatCreditsWithWord } from '@/features/ai/lib/money'
import { useCreditsDisplay } from './useCreditsDisplay'
import { CreditsDots } from './CreditsDots'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/**
 * Блок баланса в меню профиля. Вынесен из `UserProfileDropdown` ради лимита в
 * 120 строк, а не ради переиспользования: место у него одно.
 *
 * Строка баланса внутри карточки кредитов: клик по ней ведёт в окно кредитов, и
 * обработчик висит на самом пункте меню. «Пополнить» — СОСЕДНИЙ пункт, а не
 * кнопка внутри этого. Вложенная кнопка была бы интерактивным элементом
 * внутри `role="menuitem"`: Radix ведёт фокус по пунктам и внутрь не
 * заходит, то есть с клавиатуры до неё нет прямой дорожки.
 */
export const CreditsPlate = () => {
  const { balance, held, unavailable, shownBalance, share } = useCreditsDisplay()
  const m = useMessages(messages)

  return (
    <div className="w-full px-2 py-2.5">
      <div className="flex items-center justify-between gap-2">
        <span className="shrink-0 text-sm font-medium">{m.balance}</span>
        <span className="flex items-center gap-1 text-sm text-muted-foreground">
          {/* Скелет, а не «0 кредитов»: ноль у автора с деньгами на счету хуже
              пустого места. При отказе запроса — прочерк, а не вечный скелет
              (тост молчит: ручка в списке молчащих), скелет иначе выглядел бы
              как фальшивая бесконечная загрузка. */}
          {unavailable ? (
            <span>—</span>
          ) : balance ? (
            <span className="whitespace-nowrap">{formatCreditsWithWord(shownBalance)}</span>
          ) : (
            <span className="h-4 w-24 animate-pulse rounded bg-foreground/10" />
          )}
          <ChevronRight className="size-4" />
        </span>
      </div>
      {share !== null ? (
        <div className="mt-2.5">
          <CreditsDots share={share} />
        </div>
      ) : null}
      {held ? (
        <div className="mt-0.5 text-xs text-muted-foreground">{m.held(formatCredits(held))}</div>
      ) : null}
    </div>
  )
}
